import React from "react";
import Button from "../button";
import BaseModal from "../modal/base/BaseModal";

type DialogProps = {
  close: () => void;
  onClick: () => void;
  rightTitle?: string;
  title?: string;
  content?: string;
  explain?: string;
};

const ConfirmDialog = (props: DialogProps) => {
  const { close, title, content, explain, onClick, rightTitle } = props;

  return (
    <BaseModal className="p-[20px]" size="dialog" close={close}>
      <section className="flex flex-col min-h-[154px] space-y-4 justify-between ">
        <div className="w-full text-center flex-1 flex flex-col items-center space-y-2">
          <p className="text-base font-bold">{title}</p>
          <div className="flex-1 flex items-center">
            <p className="text-[#888] text-xs font-[500] whitespace-pre-line break-keep">
              {content}
            </p>
            {explain && (
              <div className="mt-[14px] bg-[#f5f5f5] rounded-[15px] p-[20px] flex items-center justify-center text-start text-[#888] font-[500] text-[12px] h-[69px]">
                {explain}
              </div>
            )}
          </div>
        </div>

        <div className="flex-row-between gap-[10px]">
          <Button
            className="w-full mt-auto  text-xl font-bold"
            label={explain ? "아니오" : "취소"}
            variant={"white"}
            onClick={close}
          />
          <Button
            className="w-full mt-auto  text-xl font-bold"
            label={explain ? "예" : rightTitle || "확인"}
            variant={"black"}
            onClick={() => {
              onClick();
              close();
            }}
          />
        </div>
      </section>
    </BaseModal>
  );
};

export default React.memo(ConfirmDialog);
